import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FaFileExcelO } from 'react-icons/lib/fa';

import { fetchContractsForDivision } from '../../actions/project_actions';
import { getDateValue } from '../../utils/date';
import { withAuth } from '../../actions/';

class ContractorsSubTab extends Component {
    constructor(props) {
        super(props);

        this.handleExportToExcel = this.handleExportToExcel.bind(this);

        this.state = {
            divisionName: '',
            contractsForDivision: props.contractsForDivision,
            isLoading: false,
        };

        this.handleReset = this.handleReset.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ contractsForDivision: nextProps.contractsForDivision })
        this.setState({isLoading: false})
    }

    UNSAFE_componentWillMount() {
        this.handleReset(); 
    }

    getOptionsForDivision(field) {
        const values = ['Infrastructure', 'Public Buildings'];
        return values.map(value => {
          return { label: value, value }
        });
      }

    handleReset() {
        this.setState({contractsForDivision: []});
    }

    renderLoading() {
      this.setState({isLoading: true});
   }

    handleSelectChangeDivision(field) {
        return (option) => {   
            const value = option ? option.value : null;
            this.setState({ divisionName: value });

            if (value === null) this.handleReset();

            if (value !== null) {
                this.handleReset();
                this.renderLoading();
                this.props.fetchContractsForDivision(value);
            }
        }
    }

    handleExportToExcel() {

        var criteria = {'DivisionName': this.state.divisionName,};
        
         let url = 'projects/ContractsExportExcel';
         let method = 'post'; 
         let responseType = 'arraybuffer';

         withAuth(
           { method, url, responseType, data: criteria },
           (response) => {
             var data = response.data;
             var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
             var blob = new Blob([data], { type: contentType }); 
             var downloadUrl= window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download='Contracts.xlsx';
                link.click();
           },
           this.errorHandler
         )
       }

    render() {
        const {divisionName, contractsForDivision, isLoading} = this.state;

        return (
            <div id="contrParentSubTab">

                    <div className="row-wide margin-top--2" id="contrSubTab">
                        <div className="col l3 m6 s12 padding-bottom-2">
                            <div className="controls with-select" id="selectRounded">
                                <label className="label-select-search">Please select a division</label>
                                <Select name={divisionName}
                                    value={divisionName}
                                    options={this.getOptionsForDivision(divisionName)}
                                    onChange={this.handleSelectChangeDivision(divisionName)}
                                />                           
                            </div>          
                        </div>
                    </div>

                {isLoading ? <div className="loader" /> : null }

            { contractsForDivision.length > 0  
               ? <div id="AeBidTracker" className="row-wide">

                        <div className="row">
                            <div className="col s6 m6 l2">
                            <h4 className="margin-bottom-0">List of all Contracts</h4>
                            </div>
                            <div className="col s6 m6 l10">
                                <button className="btn-save btn-excel float-right"  onClick={this.handleExportToExcel}>
                                    <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                                    Excel</button>
                            </div>
                        </div>

                    <div className="col s12 padding-bottom-175">
                        <div className="table-scroll height-500">
                            <table className="td-table-border th-table-border table-striped">
                                <thead>
                                <tr>
                                    <th colSpan="5"></th>
                                    <th colSpan="2" className="text-center">In Legal</th>
                                    <th colSpan="2" className="text-center">Bid Advertisement</th>
                                    <th colSpan="2" className="text-center">In Advertisement</th>
                                    <th colSpan="2" className="text-center">Bid Dates</th>
                                    <th colSpan="2" className="text-center">Pre-Award</th>
                                    <th colSpan="2" className="text-center">Award</th>
                                    <th colSpan="2" className="text-center">Execution</th>
                                    <th colSpan="2" className="text-center">Registration</th>
                                    </tr>
                                    <tr>
                                        <th>Pin</th>
                                        <th>Reg #</th>
                                        <th>Contract Type</th>
                                        <th>Vendor</th>
                                        <th>Bid Amount</th>

                                        <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start  - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    <th>Sch. Start - Sch. End</th>
                                    <th>Act. Start - Act. End</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        contractsForDivision.map((contract, index) => {

                                            return <tr key={index}>
                                                <td>{contract.pinNumber}</td>
                                                <td>{contract.regNumber}</td>
                                                <td>{contract.contractType}</td>
                                                <td>{contract.contractor}</td>
                                                <td>{contract.bidAmount}</td>

                                                {contract.inLegalSchedStart===null ? <td></td> : 
                                            <td>{getDateValue(contract.inLegalSchedStart)}&mdash;{getDateValue(contract.inLegalSchedEnd)}</td> }
                                             {contract.inLegalActualStart===null ? <td></td> : 
                                             <td>{getDateValue(contract.inLegalActualStart)}&mdash;{getDateValue(contract.inLegalActualEnd)}</td> }

                                            {contract.schedBidSchedStart===null ? <td></td> : 
                                            <td>{getDateValue(contract.schedBidSchedStart)}&mdash;{getDateValue(contract.schedBidSchedEnd)}</td>}
                                            {contract.schedBidActualStart===null ? <td></td> :
                                            <td>{getDateValue(contract.schedBidActualStart)}&mdash;{getDateValue(contract.schedBidActualEnd)}</td> }

                                            {contract.inAdvertisingSchedStart===null ? <td></td> : 
                                            <td>{getDateValue(contract.inAdvertisingSchedStart)}&mdash;{getDateValue(contract.inAdvertisingSchedEnd)}</td> }
                                            {contract.inAdvertisingActualStart===null ? <td></td> : 
                                            <td>{getDateValue(contract.inAdvertisingActualStart)}&mdash;{getDateValue(contract.inAdvertisingActualEnd)}</td> }

                                            {contract.bidDatesSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.bidDatesSchedStart)}&mdash;{getDateValue(contract.bidDatesSchedEnd)}</td> }
                                            {contract.bidDatesActualStart===null ? <td></td> :
                                            <td>{getDateValue(contract.bidDatesActualStart)}&mdash;{getDateValue(contract.bidDatesActualEnd)}</td> }

                                            {contract.preAwardSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.preAwardSchedStart)}&mdash;{getDateValue(contract.preAwardSchedEnd)}</td> }
                                            {contract.preAwardActualStart===null ? <td></td> :
                                            <td>{getDateValue(contract.preAwardActualStart)}&mdash;{getDateValue(contract.preAwardActualEnd)}</td> }

                                            {contract.awardSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.awardSchedStart)}&mdash;{getDateValue(contract.awardSchedEnd)}</td> }
                                            {contract.awardSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.awardActualStart)}&mdash;{getDateValue(contract.awardActualEnd)}</td> }

                                            {contract.executionSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.executionSchedStart)}&mdash;{getDateValue(contract.executionSchedEnd)}</td> }      
                                            {contract.executionActualStart===null ? <td></td> :
                                            <td>{getDateValue(contract.executionActualStart)}&mdash;{getDateValue(contract.executionActualEnd)}</td> }

                                            {contract.registrationSchedStart===null ? <td></td> :
                                            <td>{getDateValue(contract.registrationSchedStart)}&mdash;{getDateValue(contract.registrationSchedEnd)}</td> }
                                            {contract.registrationActualStart===null ? <td></td> :
                                            <td>{getDateValue(contract.registrationActualStart)}&mdash;{getDateValue(contract.registrationActualEnd)}</td> }

                                            </tr>
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                : null }

            </div>
        );
    }

}
function mapStateToProps(state, ownProps) {
    return {
        contractsForDivision: state.projectsStore.contractsForDivision,
    };
}

export default connect(mapStateToProps, { fetchContractsForDivision })(ContractorsSubTab);




